export default __webpack_public_path__ + "static/illustration-p1-3fc8e2e9af693f14a6254777112d1748.gif";